<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <div class="d-flex">
      <v-col cols="6" class="ml-3 mx-1 rounded content_warranty">
        <div class="ma-10">
          <div class="font-weight-bold">Thông tin sản phẩm</div>
          <hr class="border_bottom">
          <v-row class="mt-5">
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="warrantyDetail.stamp"
                  v-model="warrantyDetail.stamp"
                  label="Mã tem sản phầm"
                  placeholder="Mã tem sản phầm"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="warrantyDetail.name_product"
                  v-model="warrantyDetail.name_product"
                  label="Tên sản phầm"
                  placeholder="Tên sản phầm"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="warrantyDetail.seri"
                  v-model="warrantyDetail.seri"
                  label="Seriel"
                  placeholder="Seriel"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="buy"
                      label="Ngày mua hàng"
                      append-icon="mdi-calendar"
                      readonly
                      @blur="dateBuy = parseDate(buy)"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dateBuy"
                    @input="menu3 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="warrantyDetail.time"
                  v-model="warrantyDetail.time"
                  label="Thời gian bảo hành (tháng) "
                  placeholder="Nhập thời gian bảo hành"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="startGame"
                      label="Ngày xuất kho"
                      append-icon="mdi-calendar"
                      readonly
                      @blur="dateStart = parseDate(startGame)"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dateStart"
                    @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="endGame"
                      label="Ngày kết thúc bảo hành"
                      append-icon="mdi-calendar"
                      readonly
                      @blur="dateEnd = parseDate(endGame)"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dateEnd"
                    @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
<!--            <v-col cols="6">-->
<!--              <v-select-->
<!--                  filled-->
<!--                  class="width-input"-->
<!--                  background-color="#EDF2F7"-->
<!--                  v-model="warrantyDetail.status"-->
<!--                  :items="active"-->
<!--                  item-text="name"-->
<!--                  item-value="id"-->
<!--                  label="Chọn trạng thái kích hoạt"-->
<!--              ></v-select>-->
<!--            </v-col>-->
            <v-col cols="6">
              <v-select
                  filled
                  class="width-input"
                  background-color="#EDF2F7"
                  v-model="warrantyDetail.warranty_status"
                  :items="warranty_status"
                  item-text="name"
                  item-value="id"
                  label="Chọn trạng thái bảo hành"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <div>Ảnh hóa đơn</div>
              <v-row v-if="warrantyDetail.list_media.length > 0" >
                  <v-col cols="6" v-for="(item, index) in warrantyDetail.list_media" :key="index" class="d-flex">
                    <img  @click="scaleImage(item.path)"  :id="`img-${index}`" :src="item.path" alt="" width="300" height="300" class="item-img">
                  </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col cols="12" class="mr-3 mx-1 rounded content_warranty" >
            <div class="ma-10">
              <div class="font-weight-bold">Thông tin đại lý*</div>
              <hr class="border_bottom">
              <v-row class="mt-5">
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      :text="warrantyDetail.fullname"
                      v-model="warrantyDetail.fullname"
                      label="Họ tên"
                      placeholder="Họ tên"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      :text="warrantyDetail.phone"
                      v-model="warrantyDetail.phone"
                      label="Số điện thoại"
                      placeholder="Số điện thoại"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      :text="warrantyDetail.email"
                      v-model="warrantyDetail.email"
                      label="Email"
                      placeholder="Email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      :text="warrantyDetail.address"
                      v-model="warrantyDetail.address"
                      label="Địa chỉ"
                      placeholder="Địa chỉ"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" class="mr-3 mx-1 mt-2 rounded content_warranty" >
            <div class="ma-10">
              <div class="font-weight-bold">Thông tin khách hàng</div>
              <hr class="border_bottom">
              <v-row class="mt-5">
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      :text="warrantyDetail.customer_fullname"
                      v-model="warrantyDetail.customer_fullname"
                      label="Họ tên"
                      placeholder="Họ tên"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      :text="warrantyDetail.customer_phone"
                      v-model="warrantyDetail.customer_phone"
                      label="Số điện thoại"
                      placeholder="Số điện thoại"
                  ></v-text-field>
                </v-col>
<!--                <v-col cols="12">-->
<!--                  <v-text-field-->
<!--                      background-color="#EDF2F7"-->
<!--                      filled-->
<!--                      :text="warrantyDetail.customer_email"-->
<!--                      v-model="warrantyDetail.customer_email"-->
<!--                      label="Email"-->
<!--                      placeholder="Email"-->
<!--                  ></v-text-field>-->
<!--                </v-col>-->
                <v-col cols="12">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      :text="warrantyDetail.customer_address"
                      v-model="warrantyDetail.customer_address"
                      label="Địa chỉ"
                      placeholder="Địa chỉ"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </div>
    <div class="justify-center text-center my-5">
      <v-btn color="primary" width="180" @click="update_warranty">
        Lưu
      </v-btn>
    </div>
    <div class="scale-img" v-if="scale_img">
      <div class="close-img" @click="resizeImg">X</div>
      <img :src="scale_img" alt="" >
    </div>
  </div>
</template>
<script>
import {
  GET_DETAIL_WARRANTY,
  UPDATE_WARRANTY,
} from "@/store/modules/warranty";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dateStart: "",
      startGame:"",
      dateEnd:"",
      buy:"",
      endGame:"",
      dateBuy:"",
      menu1:false,
      menu2:false,
      menu3:false,
      page: "Chi tiết",
      scale_img: "",
      active: [
        {id:1, name:'CHƯA BẢO HÀNH'},
        {id:2, name:'ĐÃ BẢO HÀNH'},
      ],
      warranty_status: [
        {id:1, name:'CHƯA KÍCH HOẠT'},
        {id:2, name:'ĐÃ KÍCH HOẠT'},
      ],
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Bảo hành",
          disabled: true,
        },
        {
          text: "Kích hoạt bảo hành",
          disabled: true,
        },
        {
          text: "Chi tiết",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      warranties: "warranties",
      warrantyDetail: "warrantyDetail",
    }),
  },
  watch: {
    warrantyDetail(val) {
      this.dateBuy = val.buy_date
      this.dateStart = val.start_date
      this.dateEnd = this.formatDate(val.end_date)
      if (!val.time) {
        val.time = 36
      }
    },
    ['warrantyDetail.time'](value) {
      if (this.dateBuy) {
        const newDate = this.addYears(this.dateBuy, parseInt(value));
        this.dateEnd = newDate
      }
    },
    dateEnd() {
      this.endGame = this.formatDate(this.dateEnd)
    },
    dateStart() {
      this.startGame = this.formatDate(this.dateStart)

    },
    dateBuy() {
      this.buy = this.formatDate(this.dateBuy)
      this.dateEnd = this.addYears(this.dateBuy, parseInt(this.warrantyDetail.time)??0);
      this.endGame = this.dateEnd
    }

  },
  mounted() {
    this.buy = this.warrantyDetail.buy_date
    this.startGame = this.warrantyDetail.start_date
    this.endGame = this.warrantyDetail.end_date

  },
  async created() {
    await this.$store.dispatch(`${GET_DETAIL_WARRANTY}`, this.$route.params.id);
  },
  methods: {
    scaleImage(img) {
      this.scale_img = img
    },
    resizeImg() {
      this.scale_img = ""
    },
    addYears(date, month) {
      let currentDate = new Date(date)
      let newDate = new Date(currentDate.setMonth(currentDate.getMonth()+month))
      let endDate = (newDate.toISOString()).substring(0,10)
      // let year = parseInt(date.split('-')[0])+parseInt(years);
      // let newDate = year+'/'+date.split('-')[1]+'/'+date.split('-')[2]
      return endDate;
    },
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
    parseDate (date) {
      if (!date) return null
      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    update_warranty() {
      let params = {
        id: this.$route.params.id,
        address: this.warrantyDetail.address,
        buy_date: this.dateBuy,
        email:this.warrantyDetail.email,
        end_date:this.dateEnd,
        fullname:this.warrantyDetail.fullname,
        name_product:this.warrantyDetail.name_product,
        phone:this.warrantyDetail.phone,
        seri:this.warrantyDetail.seri,
        stamp:this.warrantyDetail.stamp,
        start_date:this.dateStart,
        status:this.warrantyDetail.status,
        time:this.warrantyDetail.time,
        warranty_status:this.warrantyDetail.warranty_status,
        customer_fullname:this.warrantyDetail.customer_fullname,
        customer_phone:this.warrantyDetail.customer_phone,
        customer_email:this.warrantyDetail.customer_email,
        customer_address:this.warrantyDetail.customer_address,
      }
      this.$store.dispatch(`${UPDATE_WARRANTY}`, params).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$router.push("/manage_warranty/list_warranty");
        }else {
          alert(data.data.errors)
        }
      });
    },
  }
};
</script>
<style scoped lang="scss">
.content_warranty {
  width: 50%; background: #ffffff;
  .v-input__control {
    height: 60px !important;
  }
}
.border_bottom {
  border: 1px solid lightgrey;
  width: 160px;
}
.item-img {
  margin: 5px 5px;
  border: 1px solid grey;
  border-radius: 10px;
  padding: 10px 10px;
}
.scale-img {
  max-width: 800px;
  max-height: 800px;
  position: fixed;
  top: 100px;
  border-radius: 10px;
  padding: 10px 10px;
  border: 1px solid grey;
  background: black;

  .close-img {
    position: absolute;
    right: 10px;
    top: 5px;
    font-weight: 700;
    font-size: 20px;
    border: 1px red solid;
    text-align: center;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    color: red;
    cursor: pointer;
  }

  img {
    width: 780px;
    height: 780px;
    object-fit: fill;
    border-radius: 10px;
  }
}

</style>